export default __webpack_public_path__ + "media/Meat-Egg.50740160.png";